module.exports = __webpack_public_path__ + "img/canceled.61e9eef6.png";